import { useEffect } from "react";

const ORIGIN = "https://rentway-emirates.preview.emergentagent.com";

export const useSeo = ({ title, description, jsonLd }) => {
  const key = JSON.stringify(jsonLd || null);
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    const scripts = (jsonLd || []).map((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, key]);
};

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, url], i) => ({
    "@type": "ListItem", position: i + 1, name, item: `${ORIGIN}${url}`,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question", name: f.q || f.question,
    acceptedAnswer: { "@type": "Answer", text: f.a || f.answer },
  })),
});
